import { adminV2EntryActionSchema } from '@/admin-v2/entry-actions/entry-action';
import { z } from 'zod';

export const workspaceUpdateActionSchema = adminV2EntryActionSchema.refine(
  (action) =>
    action.type === 'open_url' ||
    action.type === 'open_popup' ||
    (action.type === 'switch_to_workspace' &&
      Boolean(action.targetToolId) &&
      !action.startupInput.autoSubmit &&
      !action.startupInput.contextMappings?.length),
  'Updates must open a URL, open a popup, or select a Tool without submitting a job.'
);

export const workspaceUpdatesSchema = z.object({
  updates: z
    .array(
      z.object({
        id: z.string().min(1),
        title: z.string().min(1),
        description: z.string().min(1),
        date: z.iso.date(),
        action: workspaceUpdateActionSchema.optional(),
      })
    )
    .max(10),
});
export type WorkspaceUpdate = z.infer<
  typeof workspaceUpdatesSchema
>['updates'][number];
export const WORKSPACE_UPDATES_READ_KEY = 'imgenhancer.workspace.updates.read';
export const workspaceReadUpdatesSchema = z.array(z.string().min(1)).max(10);
